import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PAYROLL,
  DELETE_PAYROLL,
  UPDATE_PAYROLL,
  ADD_NEW_PAYROLL,
} from "./actionType";

import {
  getPayrollSuccess,
  getPayrollFail,
  deletePayrollSuccess,
  deletePayrollFail,
  updatePayrollSuccess,
  updatePayrollFail,
  addPayrollSuccess,
  addPayrollFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getPayrollApi,
  updatePayrollApi,
  deletePayrollApi,
  addNewPayrollApi
} from "../../helpers/backend_helper";

function* getPayroll({ payload: payroll }) {
  try {
    const response = yield call(getPayrollApi, payroll);
    yield put(getPayrollSuccess(GET_PAYROLL, response.data));
  } catch (error) {
    yield put(getPayrollFail(GET_PAYROLL, error));
  }
}

function* onUpdatePayroll({ payload: payroll }) {
  try {
    const response = yield call(updatePayrollApi, payroll);
    yield put(updatePayrollSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updatePayrollFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePayroll({ payload: payroll }) {
  try {
    const response = yield call(deletePayrollApi, payroll);
    yield put(deletePayrollSuccess({ payroll, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePayrollFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPayroll({ payload: payroll }) {
  try {
    const response = yield call(addNewPayrollApi, payroll);
    yield put(addPayrollSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPayrollFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPayroll() {
  yield takeEvery(GET_PAYROLL, getPayroll);
}

export function* watchUpdatePayroll() {
  yield takeEvery(UPDATE_PAYROLL, onUpdatePayroll);
}

export function* watchDeletePayroll() {
  yield takeEvery(DELETE_PAYROLL, onDeletePayroll);
}

export function* watchAddNewPayroll() {
  yield takeEvery(ADD_NEW_PAYROLL, onAddNewPayroll);
}

function* payrollSaga() {
  yield all([
    fork(watchGetPayroll),
    fork(watchDeletePayroll),
    fork(watchUpdatePayroll),
    fork(watchAddNewPayroll)
  ]);
}

export default payrollSaga;
